<template>
    <div class="news_index">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>
        <div class="mbx width_center_1200">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/news/" style="cursor: pointer;">{{className}}</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

 
    <div class="article-content">
        <div class="article-search-hd mb20">
            <div class="w w1200">
                <div class="hd-tit">{{className}}</div>
            </div>
        </div>

    <div class="w w1200 clearfix">
        <div class="article-side">
            <dl class="article-menu">
                <dt class="am-t"><a href="javascript:void(0);">分类列表</a></dt>
    <el-menu>
        <el-menu-item-group :index="v.id" v-for="v in column_list" :key="v.id">
          <el-menu-item> <a :href="'/news/'+v.id+'?name='+v.name" target="_blank">{{ v.name }}</a></el-menu-item>
        </el-menu-item-group> 
        <!-- <template slot="title">
          <span><router :href="'/news/'+v.id" target="_blank">{{ v.name }}</router></span>
        </template> -->
        <!-- <el-menu-item-group v-if="v.children">
          <el-menu-item v-for="secMenu in v.children" :key="secMenu.id"> <a :href="secMenu.url" target="_blank">{{ secMenu.name }}</a></el-menu-item>
        </el-menu-item-group> -->




        <!-- <el-submenu index="20">
        <template slot="title">
          <span><a href="#" target="_blank">联系客服</a></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1">订购流程</el-menu-item>
          <el-menu-item index="1-2">货物配送</el-menu-item>
          <el-menu-item index="1-3">货物验收</el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->
    </el-menu>
            </dl>
        </div>
        <div class="article-main">
            <div class="am-hd"><h2>{{className}}</h2></div>
                        <div class="am-bd">
                <ul class="artilce-list" v-if="list.length>0">
                   <li v-for="(v,k) in list" :key="k">
                        <h3><a :href="'/news/info/'+v.id+'?className='+ className" target="_blank" :title="v.newsTitle">{{v.newsTitle}}</a></h3>
                        <p></p>
                    </li>
                </ul>

                <div class="home_empty_list" v-else>
                    <i class="font iconfont">&#xe600;</i>暂无获取到相对应数据！
                </div>

            </div>
        <div class="home_fy_block" style="margin-top:20px;">
            <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
        </div>

        </div>
    </div>



</div>






        <ShopMbar></ShopMbar>
        <shop-foot></shop-foot>
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
    },
    data() {
      return {
          list:[],
          column_list:[],
          total_data:0, // 总条数
          page_size:10,
          current_page:1,
          type:null,
          className:null,
      };
    },
    watch: {},
    computed: {},
    methods: {
        // 新闻列表
        getList:function(){ 
            if(this.basedictId==undefined){
            this.$get(this.$api.getNewsList,{pageSize:this.page_size,pageNum:this.current_page,type:"new_state",platId:this.$platId}).then(res=>{
                this.list = res.data.list;
                this.page_size = res.data.pageSize;
                this.total_data = res.data.total;

            });
            }else{
            this.$get(this.$api.getNewsList,{pageSize:this.page_size,pageNum:this.current_page,basedictId:this.basedictId,type:"new_state",platId:this.$platId}).then(res=>{
                this.list = res.data.list;
                this.page_size = res.data.pageSize;
                this.total_data = res.data.total;

            });
            }

        },
        // 分页改变
        current_change:function(e){
            this.current_page = e;
            this.getList();
        },

        // 栏目列表
        get_column_list:function(){
            this.$get(this.$api.getNewTypes,{platId:this.$platId}).then(res=>{
                this.column_list = res.data;
            });
        },
        // handleOpen(key, keyPath) {
        //     console.log(key, keyPath);
        // },
        // handleClose(key, keyPath) {
        //     console.log(key, keyPath);
        // }  
    },
    created() {
        this.basedictId = this.$route.params.info;
        this.className = this.$route.query.name;
        this.getList();
        this.get_column_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.el-submenu [class^=el-icon-] {
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 12px;
}
.el-menu-item-group__title{
    padding: 0;
}
// .el-submenu.is-active .el-submenu__title{
//   border-bottom: none;
// }
</style>